import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrMU: CultureInfo = {
  name: 'fr-MU',
  displayName: 'français (Maurice)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-MU',
  parent: CultureInfoFr
};
